const labelBySubscription = (planCode) => {
  const subscriptionLabels = {
    fffvipa: 'Annual Subscription',
    fffvip: 'Seasonal Subscription',
    ffftrial: 'Trial SGTF',
  };
  return subscriptionLabels[planCode];
};

export { labelBySubscription };
